import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MetaInformationService } from '@services/metaInformation/meta-information.service';
import { SeoService } from '@services/seo/seo.service';
import { Microformats } from '@services/microformats/microformats.service';
import { SafeHtml } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { FaqService } from '@services/faq/faq.service';

@Component({
  selector: 'app-pqr',
  templateUrl: './pqr.component.html',
  styleUrls: ['./pqr.component.scss'],
})
export class PqrComponent implements OnInit {
  listFaq: any = [];
  textSearch: string = '';
  paginationStart: number = 0;
  paginationEnd: number = 5;
  dataForPage: number = 5;
  jsonLDPQR: SafeHtml;

  constructor(
    private metaInformationService: MetaInformationService,
    private seoService: SeoService,
    private microformats: Microformats,
    private faqService: FaqService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.getDataQuestionHelp();
    this.getDataMicroData();
    this.seoService.createCanonicalUrl();
  }

  loadMicroformats() {
    this.jsonLDPQR = this.microformats.microformatFAQ(this.listFaq);
  }

  getDataQuestionHelp(): void {
    this.faqService.getFaqHome().subscribe((data) => {
      this.listFaq = data.result;
      this.loadMicroformats();
    })
  }

  resetSetting(): void {
    if (this.textSearch.length >= 3) {
      this.paginationStart = 0;
      this.paginationEnd = 5;
    }
  }

  pagination(event): void {
    this.paginationStart = event.paginationStart;
    this.paginationEnd = event.paginationEnd;
    if (isPlatformBrowser(this.platformId)) {
      window?.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  getDataMicroData(): void {
    this.metaInformationService
      .getMetaInformation('preguntas-frecuentes', 'pages')
      .subscribe((response: any) => {
        if (response.code === 201) {
          this.seoService.generateTags(response.result[0]);
        }
      });
  }
}
